import { Form, Formik, FormikProps } from 'formik'
import React, { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import apiService from "../services/api"
import { useLogger } from "../framework/logger"
import { ArrowLeftCircle as BackIcon } from '../svgicons/ArrowLeftCircle'
import { now } from "../framework/utils/date"
import { useTranslation } from 'react-i18next'
import {  Box, Button, Theme, TextField, Typography, Badge, RadioGroup, FormControlLabel, Radio, Checkbox } from "@mui/material"
import ReactQuillEditor from '../quill/reactQuillEditor'
import { useDropzone } from 'react-dropzone'
import { BrowserUtils } from '../framework/utils'
import { makeStyles, createStyles } from "@mui/styles"
import clsx from 'classnames'
import { useRecoilState, useRecoilValue, useResetRecoilState} from 'recoil'
import Confirm from '../framework/ui/feedback/confirm'
import { Carousel } from '../models/Carousel'
import { carouselAtom, carouselImageSelector, carouselRequestNumberState } from '../atoms/carousel'
import { getCarouselValidationSchema } from '../validation/carousel'
import logConstants from '../utils/logConstants'

const useStyles = makeStyles((theme: Theme) => createStyles({
    dropzone: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '1rem',
        borderWidth: 2,
        borderRadius: 2,
        borderColor: '#eeeeee',
        borderStyle: 'dashed',
        backgroundColor: '#fafafa',
        color: '#bdbdbd',
        outline: 'none',
        transition: 'border .24s ease-in-out',
        // marginBottom: '1rem'
    },
    dragActive: {
        borderColor: '#2196f3'
    },
    dragReject: {
        border: 'solid 2px red',
        backgroundColor: '#ffe0e0',
    },
    dragAccept: {
        border: 'solid 2px green',
        backgroundColor: '#e0ffe0',
    },
    file: {
        marginTop: 8,
        cursor: 'pointer'
    },
}))

function CarouselEditPage() {
    const classes = useStyles()
    const navigate = useNavigate();
    const logger = useLogger({ key: 'carusel' });
    const { id } = useParams()
    const [ carousel, setCarousel ] = useRecoilState(carouselAtom)
    const avatar = useRecoilValue(carouselImageSelector(parseInt(id!)))
    const { t } = useTranslation()
    const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
    const [,setCarouselRequestNumberState] = useRecoilState<number>(carouselRequestNumberState)
    const resetCarousel = useResetRecoilState(carouselAtom)
    
    console.log({id})
    const handleBack = () => {
        navigate('/adm/carousel');
    }
    interface Props {
        setFieldValue: (field: string, value: any, shouldValidate?: boolean | undefined) => void
        submitForm: () => Promise<void>
    }
    
    //Component for Upload
    const UploadComponent = ({ setFieldValue, submitForm }: Props) => {
        const { getRootProps, getInputProps, isDragReject, isDragAccept, isDragActive } = useDropzone({
            //accept: "*.png, *.jpg",
            onDrop: (files) => {
                let f = files[0];
                console.log({f})
                BrowserUtils.convertFileToBase64(f)
                    .then((data: string) => {
                        console.log({data})
                        setFieldValue('fileEncoded', data)
                        setTimeout(() => {
                            submitForm()
                        }, 100)
                    })
                    .catch((err: any) => {
                        // console.log('error', err)
                    })
            }
        });

        return (
            <Box>
                <div
                    className={clsx(classes.dropzone,
                        isDragActive && classes.dragActive,
                        isDragAccept && classes.dragAccept,
                        isDragReject && classes.dragReject)}
                    {...getRootProps()}
                >
                    <input title='Drop image here' {...getInputProps()} />
                    {isDragActive ? (
                        <p>Trascina il file qui ...</p>
                    ) : (
                        <p>Trascina e rilascia dei files qui oppure fai click per selezionare i files</p>
                    )}
                </div>
            </Box>
        );
    };

    const handleDelete = () => {
    }
    
    const displayControl = (onDelete?: () => void) => {
        console.log({id})
        console.log({avatar})
        let control = avatar ? (
            <Box sx={{ overflow: 'auto' }}>
                <img src={avatar} style={{ maxWidth: 250, maxHeight: 500 }} alt='Avatar' />
            </Box>
        ) : null;
        if (onDelete) {
            control = (
                <Badge
                    color="error"
                    badgeContent="X"
                    onClick={(e: React.MouseEvent) => {
                        setIsDeleteDialogOpen(true);
                        e.stopPropagation();
                    }}
                >
                    {control}
                </Badge>
            )
        }
        return <div className={classes.file}>{control}</div>;
    }
            
    useEffect(() => {
        if (carousel.id.toString() !== id) {
            console.log('Sono nel first use effect e carico')
            //console.log(`%cDevo rileggere l'atomo ${id}`, logConstants.magenta10ptBold)
            if (id) {
                //TODO
                apiService.getCarousel(parseInt(id)).then((carous) => {
                    if(carous)
                        setCarousel(carous)
                    console.log(`%cRiletto ${id} %o`, logConstants.red12ptBold, carous)
                })
            } else {
                resetCarousel()
            }
        }    
    }, [id, resetCarousel, carousel?.id, setCarousel])

    return (
        <>
            <Box sx={{ display: 'flex', width: '100%', flexDirection: 'column' }} title={`News id: ${carousel.id}`} key={carousel.id}>
                <Box sx={{ display: 'flex', width: '100%', flexDirection: 'row', padding: '10px 0 0 13px' }}>
                    <Button onClick={handleBack} title={t('Indietro')}>
                        <BackIcon size={28} />
                    </Button>
                    <Typography variant="h3">{t('Gestione carousel')}</Typography>
                </Box>
                <Box sx={{ display: 'flex', width: '100%', flexDirection: 'row' }}>
                    <Formik
                        initialValues={carousel}
                        onSubmit={(values, { setSubmitting }) => {
                            //console.log('submitting')
                            if (carousel?.id === 0) {
                                const insertCarousel: Carousel = {
                                    id: 0,
                                    createdAt: now(),
                                    updatedAt: now(),
                                    title: values.title,
                                    argument: values.argument,
                                    payload: values.payload,
                                    imageFile: null,
                                    fileEncoded: values.fileEncoded,
                                    buttonText: values.buttonText,
                                    link: values.link,
                                    color: values.color,
                                    imageUrl: values.imageUrl,
                                    imageType: values.imageType,
                                    imageOnly: values.imageOnly,
                                    ordering: values.ordering
                                }
                                apiService.saveCarousel(insertCarousel).then(carouAdded => {
                                    if (carouAdded) {
                                        console.log('item added', carouAdded)
                                        console.log('Carou added id', carouAdded?.id)
                                        values.id = carouAdded.id
                                        setCarouselRequestNumberState(x => x + 1)
                                        navigate('/adm/carousel/' + carouAdded?.id)
                                        logger.info(`Carousel: ${carousel.title} aggiunto!`);
                                    } else {
                                        logger.error('Problemi nella creazione della news');
                                    }
                                }).catch(error => {
                                    console.error('Error in saving news');
                                    logger.error(error, 'error');
                                }).finally(() => {
                                    setSubmitting(false);
                                })
                            } else {
                                //console.log({dataUpload})
                                const updatedCarousel = {
                                    ...values,
                                    updatedAt: now(),
                                    createdAt: values?.createdAt,
                                }
                                console.log('values', values)
                                console.log('carous updated', updatedCarousel)
                                apiService.saveCarousel(updatedCarousel).then(carou => {
                                    setCarouselRequestNumberState(x => x + 1)
                                    if (carou) {
                                        console.log('carou updated', carou)
                                        logger.info(`Carou : ${carou.title} aggiornato!`);
                                    } else {
                                        logger.error('Problemi nel salvataggio della carou ');
                                    }
                                }).catch(error => {
                                    console.error('Error in saving Carousel ');
                                    logger.error(error, 'error');
                                }).finally(() => {
                                    setSubmitting(false);
                                    //props.onSubmit && props.onSubmit();                            
                                })
                            }
                        }}
                        //TODO
                        validationSchema={getCarouselValidationSchema()}
                    >
                        {(formik: FormikProps<Carousel>) => {
                            const { values, setFieldValue, handleChange, submitForm } = formik

                            return (
                                <Form style={{ width: '100%', padding: '10px 30px 10px 30px' }}>
                                    {/*
                                    <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
                                        <Box sx={{ marginBottom: '20px', display: 'flex', flexDirection: 'column' }}>
                                            <label htmlFor="id"><b>{t('Id')}</b></label>
                                            <TextField id="id" name="id" value={values.id} type="text" disabled size='small' />
                                            {formik.touched.id && formik.errors.id ? (
                                                <Box>{formik.errors.id}</Box>
                                            ) :
                                            null}
                                        </Box>
                                    </Box>
                                    */}
                                    <Box sx={{display: 'flex'}}>
                                        <Box sx={{display: 'flex', flexDirection: 'column', width: '70%'}}>
                                            <label htmlFor="title"><b>{t('Titolo')}</b></label>
                                            <Box style={{ marginBottom: '20px' }}>
                                                <TextField
                                                    id="title"
                                                    name="title"
                                                    type="text"
                                                    value={values.title}
                                                    fullWidth
                                                    onChange={handleChange}
                                                    size='small'
                                                />
                                            </Box>
                                        </Box>
                                        <Box sx={{ display: 'flex', flexDirection: 'column', width: '10%' }}>
                                            <label htmlFor="imageOnly"><b>{t('Solo immagine')}</b></label>
                                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-start', width: '60px' }}>
                                                <Checkbox
                                                    id="imageOnly"
                                                    name="imageOnly"
                                                    checked={values.imageOnly}
                                                    onChange={(event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
                                                        setFieldValue('imageOnly', checked)
                                                    }}
                                                />
                                            </Box>
                                        </Box>
                                        <Box sx={{ wodth: '10%', display: 'flex', flexDirection: 'column' }}>
                                            <label htmlFor="ordering"><b>{t('Ordinamento')}</b></label>
                                            <TextField 
                                                id="ordering" 
                                                name="ordering" 
                                                type="text" 
                                                value={values.ordering} 
                                                onChange={handleChange}
                                                size='small' 
                                                fullWidth
                                            />
                                        </Box>
                                    </Box>
                                    <Box sx={{display: 'flex'}}>
                                        <Box sx={{display: 'flex', flexDirection: 'column', width: '70%'}}>
                                            <label htmlFor="link"><b>{t('Link url')}</b></label>
                                            <Box style={{ marginBottom: '20px' }}>
                                                <TextField
                                                    id="link"
                                                    name="link"
                                                    type="text"
                                                    value={values.link}
                                                    fullWidth
                                                    onChange={handleChange}
                                                    size='small'
                                                />
                                            </Box>
                                        </Box>
                                        <Box sx={{display: 'flex', flexDirection: 'column', width: '30%'}}>
                                            <label htmlFor="color"><b>{t('Colore del testo')}</b></label>
                                            <Box style={{ marginBottom: '20px' }}>
                                                <TextField
                                                    id="color"
                                                    name="color"
                                                    type="text"
                                                    value={values.color}
                                                    fullWidth
                                                    onChange={handleChange}
                                                    size='small'
                                                />
                                            </Box>
                                        </Box>
                                    </Box>                                    
                                    <Box sx={{display: 'flex'}}>
                                        <Box sx={{display: 'flex', flexDirection: 'column', width: '70%'}}>
                                            <label htmlFor="payload"><b>{t('Contenuto (obbligatorio)')}</b></label>
                                            {/*  Editor react quill  */}
                                            <Box sx={{ border: 'solid 1px #d0d0d0', p: 1, borderRadius: '4px'}}>
                                                {formik.errors.payload && formik.touched.payload ? (
                                                    <Box sx={{ color: 'red' }}>{formik.errors.payload}</Box>
                                                )
                                                : null
                                                }
                                                <ReactQuillEditor setFieldValue={setFieldValue} fieldValue={values.payload} fieldName={'payload'} placeholder={'Scrivere il contetnuto...'} />
                                            </Box>
                                        </Box>
                                        <Box sx={{display: 'flex', flexDirection: 'column', width: '30%', pl: 1}}>
                                            <label htmlFor="imageType"><b>{t('Tipo immagine')}</b></label>
                                            <Box>
                                                <RadioGroup
                                                    aria-labelledby="demo-radio-buttons-group-label"
                                                    //defaultValue="F"
                                                    name="imageType"
                                                    onChange={handleChange}
                                                    value={values.imageType}
                                                >
                                                    <FormControlLabel value="F" control={<Radio />} label="File" />
                                                    <FormControlLabel value="U" control={<Radio />} label="Url" />
                                                </RadioGroup>
                                            </Box>
                                        </Box>
                                    </Box>
                                    <Box sx={{display: 'flex'}}>
                                        {values.imageType === 'U' ?
                                        <Box sx={{display: 'flex', flexDirection: 'column', width: '50%'}}>
                                            <label htmlFor="imageUrl"><b>{t('Url immagine')}</b></label>
                                            <Box>
                                                <TextField
                                                    id="imageUrl"
                                                    name="imageUrl"
                                                    type="text"
                                                    value={values.imageUrl}
                                                    fullWidth
                                                    onChange={handleChange}
                                                    size='small'
                                                />
                                                {formik.touched.imageUrl && formik.errors.imageUrl ? (
                                                    <Box sx={{ color: 'red' }}>{formik.errors.imageUrl}</Box>
                                                )
                                                : null}
                                            </Box>
                                        </Box>
                                        :
                                        <>
                                        <Box sx={{display: 'flex', flexDirection: 'column', width: '50%', pl: 1}}>
                                            <label htmlFor="avatar"><b>{t('Immagine del banner')}</b></label>
                                            {!avatar ?
                                                <Box sx={{ border: 'solid 1px #d0d0d0', p: 1, borderRadius: '4px'}}>
                                                    <UploadComponent setFieldValue={setFieldValue} submitForm={submitForm} />
                                                </Box>                                            
                                                :
                                                displayControl(handleDelete)
                                            }
                                        </Box>
                                        <Confirm
                                            open={isDeleteDialogOpen}
                                            onCancel={() => setIsDeleteDialogOpen(false)}
                                            onConfirm={() => {
                                                setFieldValue('imageFile', null)
                                                setFieldValue('fileEncoded', null)
                                                setTimeout(() => {
                                                    submitForm()
                                                }, 100)
                                                setIsDeleteDialogOpen(false);
                                            }}
                                        />
                                        </>
                                        }
                                    </Box>
                                    <Box sx={{ mt: 1 }}>
                                        <Button type="submit" disabled={formik.isSubmitting} title={t('Salva')} variant="outlined">
                                            {formik.isSubmitting ? "Attendere..." : ""}
                                            Salva
                                        </Button>
                                    </Box>
                                </Form>
                            )
                        }}
                    </Formik>
                </Box>
            </Box>
        </>
    )
}

export default CarouselEditPage
